import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { useQuery, UseQueryOptions } from 'react-query'
import { ExampleBrand } from 'types'
import { sendToApi } from 'api/client'

interface Data {
  example_brands: ExampleBrand[]
}

const fetchExampleBrands = async () => {
  const result = await sendToApi<Data>(`/example_brands`)

  if (result.type !== SUCCESS_RESPONSE_TYPE) {
    throw new Error()
  }
  return result.data
}

export const useExampleBrands = (options?: UseQueryOptions<Data>) =>
  useQuery<Data>(['exampleBrands', 'list'], fetchExampleBrands, {
    refetchOnWindowFocus: false,
    cacheTime: 1000 * 60 * 60 * 24,
    staleTime: 1000 * 60 * 60 * 24,
    ...options,
  })
